import { hasNoValue, isString, isValidNumber } from '@app/valdr/util';
import * as R from 'ramda';

export const compareValidator = R.curry((typeChecker, converter, comparator, value: any) =>
  hasNoValue(value) || (typeChecker(value) && comparator(converter(value)))
);

export const numberValidator = compareValidator(isValidNumber, Number);

export const stringLengthValidator = compareValidator(isString, R.length);
